<script setup lang="ts">
  import { BsTabs } from '@afo/bsf-core'
  import type { IProps } from './Tabs.types'

  defineProps<IProps>()
</script>

<template>
  <div class="documentTabs">
    <h2 class="documentTabs__header">
      {{ $t('investor.corporateGovernance.corporateDocuments.header.subtitle') }}
    </h2>

    <ClientOnly>
      <BsTabs
        class="documentTabs__container"
        v-bind="$attrs"
        :tabs="documentTabs"
      />
    </ClientOnly>
  </div>
</template>

<style lang="scss" scoped>
.documentTabs {
  &__header {
    @include h10;

    padding-bottom: .8rem;
    color: $text-400;
  }

  :deep(.bs-tabs__list) {
    flex-wrap: wrap;
    row-gap: .4rem;
    margin-bottom: 2.4rem;
  }

  :deep(.bs-tabs__button) {
    @include body-3-medium;
    margin-right: 0.8rem;
    padding: 1rem 1.6rem;
    border: 1px solid $gray-400;
    border-radius: 4.8rem;
  }

  :deep(.bs-tabs__button--selected) {
    border: 1px solid $text-400;
  }

  @include atM {
    &__header {
      @include h9;
    }
  }
}
</style>